import type { RowGesture } from '@/components/DataTable/rowClick';

/**
 * What a row gesture does once the screen size is taken into account.
 * `open` opens the record's full page instead of changing the selection.
 */
export type ResolvedRowGesture = RowGesture | 'open';

/**
 * Turns a row click's gesture into what the page should do.
 * A wide screen keeps the gesture as it is.
 * A narrow screen has no keyboard in normal use, so a tap opens the record while nothing is selected.
 * Once a long press has selected something, every tap adds or removes its row instead.
 */
export function resolveRowGesture(
    gesture: RowGesture,
    screen: { narrow: boolean; hasSelection: boolean },
): ResolvedRowGesture {
    if (!screen.narrow) return gesture;
    return screen.hasSelection ? 'toggle' : 'open';
}
